import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriberMelody} from "../../model/subscriber-melody";
import {Rule} from "../../model/rule";
import {Contact} from "../../model/contact";

@Component({
  selector: 'app-rules-block',
  templateUrl: './rules-block.component.html',
  styleUrls: ['./rules-block.component.css']
})
export class RulesBlockComponent implements OnInit {
  private _rules: Array<Rule>;
  private _contact: Contact;
  @Input() requestInProgress: boolean;
  @Input() set contact(value: Contact) {
    this._contact = value;
  }
  @Output() saveRules: EventEmitter<Array<Rule>>;
  @Output() deleteRules: EventEmitter<number>;

  melodies: ReadonlyArray<SubscriberMelody>;
  newRules: Array<Rule>;
  defaultTime: string = '00';
  showInfoModal: boolean;
  privetProSubscriptionStatus: boolean = false;

  constructor(private readonly subscriberService: SubscriberService) {
    this.saveRules = new EventEmitter<Array<Rule>>();
    this.deleteRules = new EventEmitter<number>

    this.melodies = this.subscriberService.subscriberMelodiesValue;
    this.newRules = [];
    this.showInfoModal = false;
  }

  get contact(): Contact {
    return this._contact;
  }

  isAnyPromoRuleBlocked(): boolean {
    return this.newRules.some(rule => {
      const msisdnDonator = rule.melody.msisdnDonator;
      const tariffType = rule.melody.tariffType;
      return tariffType === 'PROMO' && msisdnDonator === this._contact?.msisdn;
    });
  }

  ngOnInit(): void {
    this.melodies.forEach(melody => {
      let existingRule = this._rules.find(rule => rule.melodyIdFromPlatform == melody.idFromPlatform);

      if (existingRule) {
        existingRule.enabled = true;
        existingRule.shown = existingRule.monday || existingRule.tuesday || existingRule.wednesday || existingRule.thursday || existingRule.friday || existingRule.saturday ||
          existingRule.sunday || existingRule.startTime?.length > 0 || existingRule.endTime?.length > 0;
        if (existingRule.startTime) {
          existingRule.startTime = this.formatTime(existingRule.startTime);
        }
        if (existingRule.endTime) {
          existingRule.endTime = this.formatTime(existingRule.endTime);
        }
      }

      let rule = existingRule || new Rule();
      rule.melodyIdFromPlatform = melody.idFromPlatform;
      rule.melody = melody;
      this.newRules.push(rule);
    });
  }

  private formatTime(value: string): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');
    if (digits.length === 0) return '';

    let hours = digits.slice(0, 2);

    if (hours.length === 1) {
      hours = '0' + hours;
    }

    const numHours = parseInt(hours);
    if (numHours >= 0 && numHours <= 23) {
      return hours + ':00';
    }

    return value;
  }

  get rules(): Array<Rule> {
    return this._rules;
  }

  @Input() set rules(value: Array<Rule>) {
    this._rules = value || [];
  }

  updateRulesActivity(rule: Rule) {
    if (rule.enabled) {
      const msisdnDonator = rule.melody.msisdnDonator;
      const tariffType = rule.melody.tariffType;
      const serviceType = rule.melody.serviceType;

      if (msisdnDonator !== this._contact?.msisdn && tariffType === 'PROMO'
        && (serviceType === 'PRIVET_PLUS' || serviceType === 'PRIVET')) {
        this.privetProSubscriptionStatus = serviceType === 'PRIVET_PLUS'
        rule.enabled = false;
        this.showInfoModal = true;
        return;
      }

      let rulesToDisable = this.newRules.filter(r => r.enabled && ((rule.melody.idFromPlatform > 0 && r.melody.idFromPlatform < 0) || rule.melody.idFromPlatform < 0));
      rulesToDisable.forEach(r => r.enabled = false);
      rule.enabled = true;
    }
  }

  toggleMonday(rule: Rule): void {
    if (!(rule.startTime?.length > 0 || rule.endTime?.length > 0)) {
      rule.monday = !rule.monday;

      if (rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday) {
        rule.enabled = true;
        this.updateRulesActivity(rule)
      }
    }
  }

  toggleTuesday(rule: Rule): void {
    if (!(rule.startTime?.length > 0 || rule.endTime?.length > 0)) {
      rule.tuesday = !rule.tuesday;

      if (rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday) {
        rule.enabled = true;
        this.updateRulesActivity(rule)
      }
    }
  }

  toggleWednesday(rule: Rule): void {
    if (!(rule.startTime?.length > 0 || rule.endTime?.length > 0)) {
      rule.wednesday = !rule.wednesday;

      if (rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday) {
        rule.enabled = true;
        this.updateRulesActivity(rule)
      }
    }
  }

  toggleThursday(rule: Rule): void {
    if (!(rule.startTime?.length > 0 || rule.endTime?.length > 0)) {
      rule.thursday = !rule.thursday;

      if (rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday) {
        rule.enabled = true;
        this.updateRulesActivity(rule)
      }
    }
  }

  toggleFriday(rule: Rule): void {
    if (!(rule.startTime?.length > 0 || rule.endTime?.length > 0)) {
      rule.friday = !rule.friday;

      if (rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday) {
        rule.enabled = true;
        this.updateRulesActivity(rule)
      }
    }
  }

  toggleSaturday(rule: Rule): void {
    if (!(rule.startTime?.length > 0 || rule.endTime?.length > 0)) {
      rule.saturday = !rule.saturday;

      if (rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday) {
        rule.enabled = true;
        this.updateRulesActivity(rule)
      }
    }
  }

  toggleSunday(rule: Rule): void {
    if (!(rule.startTime?.length > 0 || rule.endTime?.length > 0)) {
      rule.sunday = !rule.sunday;

      if (rule.monday || rule.tuesday || rule.wednesday || rule.thursday || rule.friday || rule.saturday || rule.sunday) {
        rule.enabled = true;
        this.updateRulesActivity(rule)
      }
    }
  }

  timeChanged(rule: Rule): void {
    if (rule.startTime?.length > 0 || rule.endTime?.length > 0) {
      rule.enabled = true;
      this.updateRulesActivity(rule)
    }
  }

  save(): void {
    let rulesToSave = this.newRules.filter(r => r.enabled);
    rulesToSave
      .forEach(rule => {
      if (rule.startTime) {
        rule.startTime = this.cleanTime(rule.startTime);
      }

      if (rule.endTime) {
        rule.endTime = this.cleanTime(rule.endTime);
      }

      if (!rule.startTime && rule.endTime) {
        rule.startTime = this.defaultTime;
      }

      if (rule.startTime && !rule.endTime) {
        rule.endTime = this.defaultTime;
      }

      if (rule.startTime && rule.endTime && Number.parseInt(rule.startTime) == Number.parseInt(rule.endTime)) {
        rule.endTime = ((Number.parseInt(rule.startTime) + 1) % 24).toString().padStart(2, '0');
      }
    });
    if (rulesToSave.length > 0) {
      this.saveRules.emit(rulesToSave);
    } else {
      this.deleteRules.emit();
    }
  }

  private cleanTime(value: string): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');
    if (digits.length === 0) return '';

    let hours = digits.slice(0, 2);

    if (hours.startsWith('0') && hours.length > 1) {
      hours = hours.replace(/^0+/, '');
    }

    if (hours === '') {
      hours = '0';
    }

    const numHours = parseInt(hours);
    if (numHours >= 0 && numHours <= 23) {
      return numHours.toString();
    }

    return value;
  }

  protected readonly close = close;
}
